import StoryService from './StoryService';
import MomentService from './MomentService';
import CampaignService from './CampaignService';

const repository = {
	campaign: new CampaignService(),
	moment: new MomentService(),
	story: new StoryService(),
};

const install = (Vue) => {
	Vue.mixin({
		beforeCreate() {
			this.$repo = repository;
		},
	});
};

export default {
	install,
};
